import { useEffect } from "react";
import { blogs } from "./blogs";
import { setMeta, setJsonLd, SITE_URL, breadcrumbJsonLd } from "./seo";

/* Wraps blog routes so each page gets its own title, description,
   canonical URL and Article / breadcrumb schema (instead of inheriting
   the homepage's). Renders its children unchanged. */
export default function BlogMeta({ path, children }) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    if (path === "/blogs") {
      setMeta({
        title: "Blog — Documore Integrity",
        description:
          "Writing on decision integrity: why systems act on data that doesn't agree, and what changes when they stop.",
        url,
      });
      return setJsonLd("breadcrumb", breadcrumbJsonLd([
        { name: "Home", path: "/" },
        { name: "Blog", path: "/blogs" },
      ]));
    }

    const post = blogs.find((b) => b.path === path);
    if (!post) return undefined;
    const title = post.title.replace(/\s+/g, " ").trim();
    const description =
      post.desc || `${title}. A Documore decision integrity story about acting only on data that agrees.`;
    setMeta({ title: `${title} — Documore`, description, url, image: post.image, type: "article" });
    const cleanups = [
      setJsonLd("article", {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: title,
        description,
        image: post.image,
        url,
        mainEntityOfPage: url,
        author: { "@type": "Organization", name: "Documore", url: SITE_URL },
        publisher: { "@id": `${SITE_URL}/#organization` },
      }),
      setJsonLd("breadcrumb", breadcrumbJsonLd([
        { name: "Home", path: "/" },
        { name: "Blog", path: "/blogs" },
        { name: title, path },
      ])),
    ];
    return () => cleanups.forEach((c) => c());
  }, [path]);

  return children;
}
